export default {
  joboffers: [],
  filters: {},
  content: null,
  currentJoboffer: null
};
